import React, { useEffect, useState } from "react"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IInnSuggestion } from "../../../../types/inn/IInnSuggestion"

export const BicPicker: React.FC<{
  label: string
  name: string
  value: string | undefined
  errorModel: IErrorModel | undefined
  _callback: (inn: IInnSuggestion | undefined) => void
}> = ({ label, name, value, errorModel, _callback }) => {
  const [bic, setBic] = useState<IInnSuggestion>()
  const [bicValue, setBicValue] = useState<string | undefined>(value)

  useEffect(() => {
    setBicValue(value)
  }, [value])

  useEffect(() => {
    _callback(bic)
  }, [bic])

  const changeBic = (bic: string) => {
    setBicValue(bic)
    if (bic.length !== 9) {
      return
    }
    TrinityAPI.suggestBic(bic, response => {
      if (response.status === 200) {
        setBic(response.data)
      }
    })
  }

  const getFieldError = (fieldName: string) => {
    if (errorModel && errorModel.fieldErrors.filter(fe => fe.field === fieldName).length > 0) {
      return errorModel.fieldErrors.filter(fe => fe.field === fieldName)[0].defaultMessage
    }
  }

  return (
    <fieldset>
      <legend>{label}</legend>
      <input
        type="text"
        className="input-form"
        placeholder="044525225"
        onChange={e => changeBic(e.target.value)}
        value={bicValue}
      />
      {getFieldError(name) ? <p className="error-form">{getFieldError(name)}</p> : <></>}
    </fieldset>
  )
}
